import { DEV_PORT_ENV_PATTERN, DEV_PORT_FLAG_PATTERN } from '@cli-constants/patterns.js'
import { isValidPort } from '@cli-utils/shared.js'

export function detectDevPortFromScript(devScript?: string): number | undefined {
  if (typeof devScript !== 'string') return undefined

  const trimmed = devScript.trim()
  if (trimmed.length === 0) return undefined

  const flagMatch = trimmed.match(DEV_PORT_FLAG_PATTERN)
  const envMatch = trimmed.match(DEV_PORT_ENV_PATTERN)
  const rawPort = flagMatch?.[1] ?? envMatch?.[1]
  if (!rawPort) return undefined

  const port = Number.parseInt(rawPort, 10)
  return isValidPort(port) ? port : undefined
}
